import { render, staticRenderFns } from "./TableCellProductVariablesTitle.vue?vue&type=template&id=2d7de848&scoped=true"
import script from "./TableCellProductVariablesTitle.vue?vue&type=script&lang=js"
export * from "./TableCellProductVariablesTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7de848",
  null
  
)

export default component.exports